import { Flexbox } from '@/ui/flexbox/flexbox';
import { SmallText } from '@/ui/typography/widgets';
import { styled } from 'goober';

export const FilterButton = <T,>({
  label,
  type,
  quantity,
  onClick,
  isActive,
}: {
  label: string;
  type: T;
  quantity: number;
  onClick: (filter: T) => void;
  isActive: boolean;
}) => {
  return (
    <FilterContainer
      alignItems="center"
      gap="6px"
      data-testid={`filter-${label.toLowerCase()}`}
      onClick={() => onClick(type)}
    >
      <Label isActive={isActive}>{`${label} (${quantity})`}</Label>
    </FilterContainer>
  );
};

const FilterContainer = styled(Flexbox)`
  cursor: pointer;
`;

const Label = styled(SmallText)<{ isActive: boolean }>`
  color: ${({ isActive, theme }) =>
    isActive ? theme.colors.blue.primaryA : theme.colors.gray.c10};
  font-weight: ${({ isActive }) => (isActive ? '600' : '400')};
  position: relative;

  ${({ isActive, theme }) =>
    isActive &&
    `
    &:after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${theme.colors.blue.primaryA};
    }
  `}
`;
